export default {
  home: "/",
  login: "/login",
  before: "/antes-de-partir",
  thanks: "/muchas-gracias",
  comments: "/comentarios",
  survey: "/encuesta",
}
